package com.essntl.features.dashboard.ui.components.itineraryCard

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.focus.focusProperties
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.unit.dp
import core.dateformat.utils.convertTimestampToTimeAgo
import com.essntl.core.utils.utils.capitalizeFirstLetter
import com.essntl.features.dashboard.ui.DashboardState
import com.essntl.features.itinerary.domain.model.ItineraryToConfirmModel
import com.essntl.features.itinerary.domain.model.servicesToConfirmText
import com.essntl.features.profile.ui.OwnerItem
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.rememberEquals
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import core.dateformat.ui.formatDateRange

@Composable
fun ItineraryCard(
    itinerary: ItineraryToConfirmModel,
    state: DashboardState,
    selectedId: String?,
    onClick: () -> Unit,
) {
    val isSelected = rememberEquals(itinerary.id, setOf(selectedId)) { it }

    Box(
        modifier = Modifier
            .clip(RoundedCornerShape(16.dp))
            .size(200.dp)
            .background(
                color = when {
                    isSelected ->
                        MaterialTheme.esColorScheme.tintedPressed

                    else -> MaterialTheme.esColorScheme.bgPrimary
                },
            )
            .pointerHoverIcon(PointerIcon.Hand)
            .focusProperties { canFocus = false }
            .clickable(onClick = onClick)
            .padding(2.spacing),
    ) {
        Text(
            text = itinerary.servicesToConfirmText(),
            style = MaterialTheme.esTypography.p2Medium14.copy(
                color = if (itinerary.unconfirmedServiceCount != 0) Color.Red else MaterialTheme.esColorScheme.textSecondary,
            ),
            modifier = Modifier.align(Alignment.TopStart),
        )

        Column(
            verticalArrangement = Arrangement.spacedBy(.5.spacing),
            modifier = Modifier.align(Alignment.CenterStart),
        ) {
            Text(
                text = listOf(
                    itinerary.fromDate,
                    itinerary.toDate,
                ).formatDateRange(),
                style = MaterialTheme.esTypography.p2Regular14.copy(
                    color = MaterialTheme.esColorScheme.textPrimary,
                ),
            )
            Text(
                text = itinerary.title,
                style = MaterialTheme.esTypography.p1Medium16.copy(
                    color = MaterialTheme.esColorScheme.textPrimary,
                ),
            )
            Text(
                text = itinerary.clientName.capitalizeFirstLetter(),
                style = MaterialTheme.esTypography.p2Regular14.copy(
                    color = MaterialTheme.esColorScheme.textSecondary,
                ),
            )
            Text(
                text = "Created ${convertTimestampToTimeAgo(itinerary.createdAt)}",
                style = MaterialTheme.esTypography.p2Medium14.copy(
                    color = MaterialTheme.esColorScheme.textDisabled,
                ),
            )
        }

        if (state.filterOptions.selectedProfileIds.isEmpty())
            OwnerItem(
                ownerId = itinerary.ownerId,
                getAllProfile = state.getAllProfile,
                isUpdateOwnerLoading = false,
                enabled = false,
                onOwnerChange = { },
                modifier = Modifier.align(Alignment.BottomEnd),
            )
    }
}